import { render, staticRenderFns } from "./StorageManagement.vue?vue&type=template&id=bc4afc04&"
import script from "./StorageManagement.vue?vue&type=script&lang=js&"
export * from "./StorageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports